import MatterTagsView from "@/components/features/settings/defaults/matter-tags/MatterTagsView";

export default function MatterTagsCard() {
  return <MatterTagsView />;
}
